import { Box, Divider, Typography } from '@wishket/design-system';

import { EXTERNAL_LINKS } from '../Footer.constants';

import { Link } from '@/shared/Components';

const CompanyInfo = () => {
  return (
    <Box
      className="flex flex-col gap-4 grid-in-company"
      data-testid="footer-company-info"
    >
      <Box className="flex items-center gap-2">
        <Link
          target="_blank"
          href={EXTERNAL_LINKS.TERMS_SERVICE}
          data-testid="footer-terms-service-link"
        >
          <Typography
            variant="body1"
            className="text-w-gray-600 hover:underline"
          >
            이용약관
          </Typography>
        </Link>
        <Divider className="h-4" isVertical />

        <Link
          target="_blank"
          href={EXTERNAL_LINKS.TERMS_PRIVACY}
          data-testid="footer-terms-privacy-link"
        >
          <Typography
            variant="body1"
            className="font-bold text-w-gray-600 hover:underline"
          >
            개인정보 처리방침
          </Typography>
        </Link>

        <Divider className="h-4" isVertical />
        <Link
          target="_blank"
          href={EXTERNAL_LINKS.TERMS_YOUTH_PROTECTION}
          data-testid="footer-terms-youth-protection-link"
        >
          <Typography
            variant="body1"
            className="text-w-gray-600 hover:underline"
          >
            청소년보호정책
          </Typography>
        </Link>
      </Box>

      <address className="flex w-full max-w-[980px] flex-col flex-wrap gap-x-2 gap-y-1.5 not-italic leading-[14px] text-w-gray-400 tablet:flex-row desktop:min-w-[932px]">
        <Box className="flex items-center gap-2 tablet:w-full desktop:w-fit">
          <Typography variant="body3" className="">
            ㈜위시켓
          </Typography>
          <Divider className="h-3.5" isVertical />
          <Typography variant="body3">대표이사 : 박우범</Typography>
        </Box>

        <Box className="flex items-center gap-2 desktop:w-[70%]">
          <Divider className="hidden h-3.5 desktop:block" isVertical />
          <Typography variant="body3" className="">
            서울특별시 강남구 테헤란로 211 3층 ㈜위시켓
          </Typography>
        </Box>

        <Box className="flex items-center gap-2 tablet:w-1/2 desktop:w-fit">
          <Divider
            className="hidden h-3.5 tablet:block desktop:hidden"
            isVertical
          />
          <Typography variant="body3">사업자등록번호 : 209-81-57303</Typography>
        </Box>

        <Box className="flex items-center gap-2">
          <Divider className="hidden h-3.5 desktop:block" isVertical />
          <Typography variant="body3">
            통신판매업신고 : 제2018-서울강남-02337 호
          </Typography>
        </Box>

        <Box className="flex items-center gap-2 tablet:w-[60%] desktop:w-[45%] ">
          <Divider
            className="hidden h-3.5 tablet:block desktop:block"
            isVertical
          />
          <Typography variant="body3">
            직업정보제공사업 신고번호 : J1200020180019
          </Typography>
        </Box>

        <Box className="flex items-center gap-2">
          <Typography variant="body3">제호 : 요즘IT</Typography>
          <Divider className="h-3.5" isVertical />
          <Typography variant="body3">발행인 : 박우범</Typography>
        </Box>

        <Box className="flex items-center gap-2 tablet:w-3/4 desktop:w-fit">
          <Divider className="hidden h-3.5 tablet:block" isVertical />
          <Typography variant="body3">편집인 : 노희선</Typography>
          <Divider className="h-3.5" isVertical />
          <Typography variant="body3">청소년보호책임자 : 박우범</Typography>
        </Box>

        <Box className="flex items-center gap-2">
          <Divider className="hidden h-3.5 desktop:block" isVertical />
          <Typography variant="body3">
            인터넷신문등록번호 : 서울,아54129
          </Typography>
        </Box>

        <Box className="flex items-center gap-2">
          <Divider className="hidden h-3.5 desktop:block" isVertical />
          <Typography variant="body3">등록일 : 2022년 01월 23일</Typography>
          <Divider className="h-3.5" isVertical />
          <Typography variant="body3">발행일 : 2021년 01월 10일</Typography>
        </Box>
      </address>

      <Typography variant="body3" className="text-w-gray-400">
        © 2013 Wishket Corp.
      </Typography>
    </Box>
  );
};

export default CompanyInfo;
